import { BID, GET_BID_COUNT_SHWE_HOUR } from "./contants";

const initState = {
  bid: [],
  shweHourBidCount: {
    reward: null,
    totalBids: 0,
    isReceived: false,
  },
};

const reducerBid = (state = initState, actions) => {
  switch (actions.type) {
    case BID:
      return {
        ...state,
        bid: actions.payload.data,
      };
    case GET_BID_COUNT_SHWE_HOUR:
      return {
        ...state,
        shweHourBidCount: actions.payload.data,
      };
    default:
      return state;
  }
};

export default reducerBid